<template>
  <div class="wrapper ecommerce-page">
    <div class="page-header page-header-mini"></div>
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <div class="collapse-panel">
                <div class="card-body">
                  <div class="card card-refine card-plain">
                    <div>
                      <fg-input
                        class="search_input"
                        placeholder="搜尋商品"
                        addon-right-icon="now-ui-icons ui-1_zoom-bold"
                        v-model="search"
                        @input="handleChangeSearch"
                      ></fg-input>
                    </div>
                    <div>
                      <el-select
                        :clearable="true"
                        v-model="category"
                        placeholder="商品類別"
                        class="select-info"
                        @change="handleChangeCategory"
                      >
                        <el-option
                          v-for="item in productCategory"
                          :key="item.product_category_id"
                          :label="item.name"
                          :value="item.product_category_id"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        :clearable="true"
                        v-model="brand"
                        placeholder="商品類別"
                        class="select-info"
                        @change="handleChangeBrand"
                      >
                        <el-option
                          v-for="item in filteredBrand"
                          :key="item.product_brand_id"
                          :label="item.name"
                          :value="item.product_brand_id"
                        ></el-option>
                      </el-select>
                    </div>
                    <!-- <h6 class="mb-0 text-info" slot="title">
                          品牌分類
                          <i class="now-ui-icons arrows-1_minimal-down"></i>
                        </h6>
                        <n-checkbox
                          v-for="desginer in productBrand"
                          v-model="desginer.name"
                          :key="desginer.name"
                          >{{ desginer.name }}</n-checkbox
                    >-->
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-9">
              <div class="row">
                <div
                  class="col-lg-4 col-md-6"
                  v-for="all in product"
                  :key="all.product_id"
                  @click="gotoproduct(all)"
                >
                  <card type="product" plain>
                    <img slot="image" :src="all.cover.path" alt />

                    <a href="#">
                      <h4 class="card-title">{{ all.name }}</h4>
                    </a>
                    <!-- <p class="card-description">{{product.description}}</p> -->
                    <div class="card-footer">
                      <div class="price-container">
                        <div class="row">
                          <div class="col-md-12">
                            <span class="price">最低月付金額</span>
                            <span class="price money">＄{{ all.price }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <infinite-loading @infinite="loadMore" :identifier="loadingIdentifier">
      <div slot="no-more">沒有更多商品囉</div>
      <div slot="no-results">沒有更多商品囉</div>
    </infinite-loading>
  </div>
</template>
<script>
import {
  Card,
  Button,
  InfoSection,
  FormGroupInput,
  Checkbox,
  Collapse,
  CollapseItem,
  Slider
} from "@/components";
import { Carousel, CarouselItem, Tooltip, Select, Option } from "element-ui";
import gql from "graphql-tag";
import InfiniteLoading from "vue-infinite-loading";
import _ from "lodash";
import Vue from "vue";

Vue.use(InfiniteLoading, {
  props: {
    distance: 800
  },
  system: {
    throttleLimit: 100
  }
});

export default {
  name: "ecommerce-page",
  bodyClass: "ecommerce-page",
  components: {
    Card,
    InfoSection,
    Collapse,
    CollapseItem,
    Slider,
    InfiniteLoading,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Tooltip.name]: Tooltip,
    [Option.name]: Option,
    [Select.name]: Select
  },
  apollo: {
    productCategory: {
      query: gql`
        query {
          productCategory {
            product_category_id
            name
          }
        }
      `
    },
    productBrand: {
      query: gql`
        query {
          productBrand {
            product_brand_id
            name
            product_category_id
            category {
              product_category_id
              name
            }
          }
        }
      `
    }
  },
  computed: {
    filteredBrand() {
      return this.productBrand.filter(
        b => b.product_category_id === this.category
      );
    },
    loadingIdentifier() {
      const id = `${this.search}-${this.category}-${this.brand}-`;
      console.log("id", id);
      return id;
    }
  },
  data() {
    return {
      productCategory: [],
      productBrand: [],
      product: [],
      category: null,
      brand: null,
      offset: 0,
      limit: 6,
      busy: false,
      search: ""
    };
  },
  methods: {
    test() {
      console.log("search", this.search);
    },
    gotoproduct(all) {
      this.$router.push({
        name: "product",
        params: {
          product_id: all.product_id
        },
        query: this.$route.query
      });
    },
    async loadMore($state) {
      const q = await this.$apollo.query({
        query: gql`
          query(
            $product_category_id: Int
            $product_brand_id: Int
            $offset: Int
            $limit: Int
            $search: String
          ) {
            product(
              product_category_id: $product_category_id
              product_brand_id: $product_brand_id
              offset: $offset
              limit: $limit
              search: $search
            ) {
              product_id
              name
              price
              summary
              description
              notice
              cover {
                file_id
                path
              }
              category {
                name
              }
              brand {
                name
              }
            }
          }
        `,
        variables: {
          product_category_id: this.category === "" ? null : this.category,
          product_brand_id: this.brand === "" ? null : this.brand,
          offset: this.offset,
          limit: this.limit,
          search: this.search
        },
        fetchPolicy: "network-only"
      });

      this.product.push(...q.data.product);
      this.offset += this.limit;
      if (q.data.product.length === 0) $state.complete();
      else $state.loaded();
    },
    check() {
      console.log("product", this.product);
      console.log("offset", this.offset);
    },
    resetProduct() {
      this.offset = 0;
      this.product = [];
    },
    handleChangeSearch() {
      this.resetProduct();
    },
    handleChangeCategory() {
      this.brand = null;
      this.resetProduct();
    },
    handleChangeBrand() {
      this.resetProduct();
    }
  }
};
</script>
<style lang="scss" scoped>
.page-header:before {
  background: -webkit-linear-gradient(left top, white, #fedfe1);
  background: -o-linear-gradient(bottom right, white, #fedfe1);
  background: -moz-linear-gradient(bottom right, white, #fedfe1);
  background: linear-gradient(to bottom right, white, #fedfe1);
}
.page-header:after {
  background: -webkit-linear-gradient(left top, white, #fedfe1);
  background: -o-linear-gradient(bottom right, white, #fedfe1);
  background: -moz-linear-gradient(bottom right, white, #fedfe1);
  background: linear-gradient(to bottom right, white, #fedfe1);
}
.search_input {
  margin: 0 0 10px 0;
}
h6 {
  font-size: 1.1em;
}

img {
  height: 20vh;
}

.money {
  color: red !important;
}
.page-header-mini {
  min-height: 100px !important;
  max-height: 10px;
}

@media screen and (max-width: 600px) {
  .page-header-mini {
    min-height: 120px !important;
    max-height: 10px;
  }
  .section {
    padding: 0 0 0 0;
  }
  h6 {
    font-size: 1em;
  }
  img {
    height: 30vh;
  }
  .price {
    text-align: center;
  }
}
</style>
